import React, {useState} from 'react';
import AvailBenifitModal from '../AvailBenifitModal/AvailBenifitModal';

import * as S from './EarnMore.styles';

const EarnMore = ({
  icon,
  heading,
  subHeading,
  listData,
  cta,
  knowMoreData,
  ccdeCookie,
  bannersArray = [],
  walletPromotionConfigData = [],
}) => {
  const [knowMore, setKnowMore] = useState(false);

  const toggleBenefitModal = () => {
    setKnowMore(!knowMore);
  };

  return (
    <>
      {ccdeCookie === 'AE' && bannersArray?.length ? (
        bannersArray?.map(({url, cta}, index) => {
          return (
            <div onClick={() => cta && window.open(cta, '_blank')}>
              <S.BannerImage src={url} key={index} isClickable={cta} />
            </div>
          );
        })
      ) : (
        <>
          <S.EarnMoreCont>
            <S.HeaderDiv>
              {icon && <img width={24} src={icon} />}
              {heading && <S.EarnMoreHeading>{heading}</S.EarnMoreHeading>}
            </S.HeaderDiv>
            {subHeading && <S.EarnMoreSubHeading dangerouslySetInnerHTML={{__html: subHeading}} />}
            <S.EarnMoreBody>
              {listData && listData.length > 0 && (
                <S.EarnMoreList>
                  {listData.map(({id, labelText}, index) => (
                    <li key={id}>
                      <S.EarnMoreListStep>
                        <span>Step:</span> {index + 1}
                      </S.EarnMoreListStep>
                      <p dangerouslySetInnerHTML={{__html: labelText}} />
                    </li>
                  ))}
                </S.EarnMoreList>
              )}
              <S.Note>
                {ccdeCookie === 'AE'
                  ? 'Note - Applicable on minimum recharge of 3000 AED via Cash Deposit or Bank transfer. No minimum recharge amount required to avail benefit via CC/DC. Cashback will be valid for 1 year and can be used on all flight bookings without any restrictions'
                  : 'Note - Cashback will be valid for 1 year and can be used on both flight & hotel bookings without any restrictions'}
              </S.Note>
              {cta && (
                <S.EarnMoreCta>
                  <a onClick={toggleBenefitModal}>{cta}</a>
                </S.EarnMoreCta>
              )}
            </S.EarnMoreBody>
          </S.EarnMoreCont>
          {ccdeCookie !== 'AE' ? (
            <>
              <>
                {bannersArray?.map(({url, cta}, index) => {
                  return (
                    <div onClick={() => cta && window.open(cta, '_blank')}>
                      <S.BannerImage src={url} key={index} isClickable={cta} />
                    </div>
                  );
                })}
              </>
              <>
                {walletPromotionConfigData?.map(({url, cta}, index) => {
                  return (
                    <div onClick={() => cta && window.open(cta, '_blank')}>
                      <S.BannerImage src={url} key={index} isClickable={cta} />
                    </div>
                  );
                })}
              </>
            </>
          ) : null}
        </>
      )}
      {knowMore && (
        <AvailBenifitModal
          heading="Avail the benefit"
          closeBtn={true}
          listData={knowMoreData}
          onClose={toggleBenefitModal}
        />
      )}
    </>
  );
};

export default EarnMore;
